import { createContext } from "react";
import { ClientOnly } from "../Components/ClientOnly";
import { ApiIdentityService as ApiIdentityServiceClass } from "../services/apiIdentityService";

export const ApiIdentityServiceContext = createContext<ApiIdentityServiceClass|null>(null);

function ApiIdentityServiceProducer({ children }: { children: React.ReactNode }) {
    return (
        <ApiIdentityServiceContext.Provider value={ApiIdentityServiceClass.getInstance()}>
            {children}
        </ApiIdentityServiceContext.Provider>
    );
}

export function ApiIdentityService({ children }: { children: React.ReactNode }) {
    return (
        <ClientOnly>
            <ApiIdentityServiceProducer>
                {children}
            </ApiIdentityServiceProducer>
        </ClientOnly>
    );
}
